/**
 * Detects brand signup/login flows from query params, including encoded redirects
 * (e.g. `?redirect=%2Fbrand` → `/brand`).
 */
export function isBrandAuthFlow(redirect: string | null | undefined, viewParam?: string | null | undefined): boolean {
    const v = viewParam?.trim().toLowerCase();
    if (v === 'brand') return true;

    if (redirect == null || String(redirect).trim() === '') return false;

    let s = String(redirect).trim();
    try {
        s = decodeURIComponent(s);
    } catch {
        // keep raw
    }

    const lower = s.toLowerCase();

    if (lower === 'brand' || lower === '/brand' || lower.startsWith('/brand/')) return true;
    if (lower.includes('/brand')) return true;

    // Rare: value still contains literal %2F (decode failed or partial)
    if (/%2f\s*brand\b/i.test(lower)) return true;

    if (lower.startsWith('http://') || lower.startsWith('https://')) {
        try {
            const path = new URL(s).pathname.toLowerCase();
            return path === '/brand' || path.startsWith('/brand/');
        } catch {
            return false;
        }
    }

    return false;
}
